import { useState, useEffect } from 'react';
import { useAccount } from 'wagmi';

type FeeData = {
    mintTokenGasEstimate: string;
    transferGasEstimate: string;
    approveGasEstimate: string;
    gasPrice: string;
    bridgingFee: string;
    usd: string;
  };
  type Chain =
  | 'ethereum'
  | 'polygon'
  | 'binance'
  | 'optimism'
  | 'arbitrum'
  | 'goerli'
  | 'sepolia'
  | 'mumbai'
  | 'bsc-testnet'

  function useFetchFee(source: Chain | undefined, dest: Chain | undefined, tokenId: number|undefined) {
    
    const { address } = useAccount()
    const [data, setData] = useState<FeeData | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);
  
    useEffect(() => {
      if (source && dest && tokenId) {
        setIsLoading(true);
        fetch(`/api/gas/bridgefee?source=${source}&dest=${dest}&tokenid=${tokenId}`,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            address: address,
          }),
        })
          .then(res => res.json())
          .then((data: FeeData) => {
            setData(data);
            setIsLoading(false);
          })
          .catch((err: Error) => {
            setError(err);
            setIsLoading(false);
          });
      }
    }, [source, dest, tokenId]);
  
    return { data, isLoading, error };
  }
  
  export default useFetchFee;